export const STATUS_HTTP = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  NAO_EXISTE: 404,
  ERRO_NO_SERVIDOR: 500
}
